import React from 'react';

export function Header() {
    return (
        <div className="bg-white shadow-sm">
            <div className="flex flex-col md:flex-row items-center py-6 md:py-8 px-4 md:px-8">
                <div className="flex w-full md:w-1/6 items-center relative mt-4 mb-4 md:my-0">
                    {/* Mobile: Space for hamburger */}
                    <div className="w-12 md:hidden"></div>

                    {/* Logo - centered on mobile, left on desktop */}
                    <div className="flex absolute left-1/2 -translate-x-1/2 md:static md:translate-x-0 md:justify-center">
                        <a href="https://intail.ai" target="_blank" rel="noopener noreferrer">
                            <img src="/intail-logo.svg" alt="Intail Logo" className="h-10 md:h-12 w-auto" />
                        </a>
                    </div>
                </div>

                {/* Separator for mobile */}
                <div className="w-full h-px bg-gray-200 my-6 md:hidden"></div>

                {/* Title and Description - centered on mobile */}
                <div className="flex-1 md:w-5/6 md:mt-0 md:px-4 text-center md:text-left">
                    <h1 className="text-xl md:text-2xl font-bold bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 bg-clip-text text-transparent tracking-tight">
                        VC Index Israel
                    </h1>
                    <p className="mt-2 text-gray-600 text-xs md:text-sm font-light">
                        Discover and explore venture capital firms in Israel
                    </p>
                </div>
            </div>
        </div>
    );
} 